import React from "react";
import { Badge, Box, Group, Paper, SimpleGrid, Stack, Text } from "@mantine/core";

export const DueDiligenceBadge = ({ color, children }) => (
  <Badge color={color} variant="light" size="lg" sx={{ flexShrink: 0 }}>
    {children}
  </Badge>
);

export const DueDiligencePanel = ({
  title,
  required = false,
  headline,
  meta,
  badge,
  note,
  noteColor = "gray",
  children,
}) => {
  const hasHeader = Boolean(headline || meta || badge);
  const hasChildren = React.Children.toArray(children).length > 0;
  return (
    <Box>
      {title ? (
        <Text
          transform="uppercase"
          size="xs"
          weight={600}
          color="gray.7"
          mb="xs"
        >
          {title}
          {required ? (
            <Text component="span" color="red">
              {" "}
              *
            </Text>
          ) : null}
        </Text>
      ) : null}
      <Paper
        p="lg"
        radius={0}
        shadow="sm"
        sx={(theme) => ({
          border: `1px solid ${
            theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3]
          }`,
        })}
      >
        {hasHeader ? (
          <Group position="apart" align="flex-start" noWrap spacing="md">
            <Stack spacing={2} sx={{ flex: 1, minWidth: 0 }}>
              {headline ? (
                <Text size="lg" weight={600} sx={{ wordBreak: "break-word" }}>
                  {headline}
                </Text>
              ) : null}
              {meta ? (
                <Text size="sm" color="dimmed">
                  {meta}
                </Text>
              ) : null}
            </Stack>
            {badge}
          </Group>
        ) : null}
        {note ? (
          <Box
            mt={hasHeader ? "md" : 0}
            pl="sm"
            py={2}
            sx={(theme) => ({
              borderLeft: `3px solid ${
                theme.colors[noteColor]?.[5] || theme.colors.gray[5]
              }`,
            })}
          >
            <Text size="sm">{note}</Text>
          </Box>
        ) : null}
        {hasChildren ? <Box mt={hasHeader || note ? "md" : 0}>{children}</Box> : null}
      </Paper>
    </Box>
  );
};

export const DueDiligenceFacts = ({ items }) => (
  <SimpleGrid
    cols={Math.min(items.length, 3)}
    spacing="sm"
    breakpoints={[{ maxWidth: "sm", cols: 1 }]}
  >
    {items.map((item) => (
      <Box
        key={item.label}
        p="sm"
        sx={(theme) => ({
          backgroundColor:
            theme.colorScheme === "dark"
              ? theme.colors.dark[6]
              : theme.colors.gray[0],
          borderRadius: theme.radius.sm,
        })}
      >
        <Text size="xs" color="dimmed">
          {item.label}
        </Text>
        <Box mt={6}>{item.value}</Box>
      </Box>
    ))}
  </SimpleGrid>
);
